import React, { Component } from "react";

import { Flex } from "reflexbox";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Modal, Button } from "antd";
import startCase from "lodash/startCase";
import moment from "moment";

import { api } from "../../services";
import { usersStore, registrationStore } from "../../stores";

function Status(props) {
  return (
    <Flex className="Status">
      <div className={props.status > 0 ? "full" : ""} />
      <div className={props.status > 2 ? "full" : ""} />
      <div className={props.status > 5 ? "full" : ""} />
    </Flex>
  );
}

@inject("translationsStore", "registrationStore")
@withRouter
@observer
class PendingRegistration extends Component {
  startCase(...word) {
    return word
      .map(w => (w || "").toLowerCase())
      .map(w => startCase(w))
      .join(" ");
  }

  handleRowClick = e => {
    this.props.history.push(`/registration/${this.props.user._id}`);
  };

  handleDelete = e => {
    const { current: t } = this.props.translationsStore;
    e.preventDefault();
    e.stopPropagation();
    const { _id } = this.props.user;
    Modal.confirm({
      title: `${t["pendingList"]["popupRemoveRegistration"]["header"]}`,
      content: `${t["pendingList"]["popupRemoveRegistration"]["description"]} ${this.startCase(this.props.user.firstname, this.props.user.lastname)}?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        api({ action: "delete user" }, _id).then(result => {
          usersStore.load();
          registrationStore.user = undefined;
        });
      }
    });
    return false;
  };

  render() {
    const u = this.props.user;
    const t = this.props.translationsStore.current;

    return (
      <Flex className="PendingRegistration" onClick={this.handleRowClick}>
        <Flex auto w={1 / 6} align={"center"} justify={"center"}>
          {u.assets[0].subscription.signatureDate && moment(u.assets[0].subscription.signatureDate).format("L")}
        </Flex>
        <Flex auto w={1 / 6} align={"center"} justify={"center"}>
          {u.ragsoc ? u.ragsoc : this.startCase(u.firstname, u.lastname)}
        </Flex>
        <Flex align={"center"} justify={"center"} auto w={1 / 6}>
          {u.assets[0].imei}
        </Flex>
        <Flex align={"center"} justify={"center"} auto w={1 / 6} className="upperCase">
          {u.assets[0].car.plate}
        </Flex>
        <Flex align={"center"} justify={"center"} auto w={1 / 6}>
          <Status status={u.assets[0].subscription.status} />
        </Flex>
        <Flex align={"center"} justify={"center"} auto w={1 / 6} onClick={this.handleDelete}>
          <Button type="danger" disabled={this.props.user.assets[0].subscription.status >= 6}>
            {t["shared"]["btnDelete"]}
          </Button>
        </Flex>
      </Flex>
    );
  }
}

export default PendingRegistration;



// WEBPACK FOOTER //
// ./src/components/Registrations/PendingRegistration.js